// extracted by css-extract-rspack-plugin
export default {"cls1":"CoScientistLandingPage-cls1_2f-","cls2":"CoScientistLandingPage-cls2_GUC CoScientistLandingPage-cls1_2f-"};